<script setup lang="ts">
/**
 * UI-kit component
 * Category: Tables
 * Name: 'AppTr'
 */
import type { AppTrProps } from '../types/interfaces'

defineOptions({
  name: 'AppTr',
})

withDefaults(defineProps<AppTrProps>(), {
  disabled: false,
  selected: false,
})
</script>

<template>
  <tr :class="['app-tr', { 'is-disabled': disabled, selected }]">
    <slot />
  </tr>
</template>

<style lang="scss" scoped src="../styles/_app-table.scss" />
